import { Button } from "@radix-ui/themes";
import { useAppDispatch, useAppSelector } from "@/app/appStore";
import {
  selectIsPlanogramSourceImageVisible,
  togglePlanogramOverlay,
} from "@/entities/annotation";

import { ViewVerticalIcon } from "@radix-ui/react-icons";

const PlanogramToggle = () => {
  const dispatch = useAppDispatch();
  const isPlanogramSourceImageVisible = useAppSelector(
    selectIsPlanogramSourceImageVisible
  );

  return (
    <>
      <Button
        size="1"
        variant={isPlanogramSourceImageVisible ? "solid" : "soft"}
        color="gray"
        mr="1"
        onClick={() => dispatch(togglePlanogramOverlay())}
      >
        <ViewVerticalIcon />
        Toggle planogram source image
      </Button>
    </>
  );
};

export default PlanogramToggle;
